import { motion, useReducedMotion } from "motion/react";
import { mesaPageMotion } from "./motion";

export default function MesaShell({ children, className = "" }) {
  const reduced = useReducedMotion();
  const motionProps = reduced
    ? {}
    : mesaPageMotion;

  return (
    <motion.div
      className={`mesa-shell${className ? " " + className : ""}`}
      {...motionProps}
    >
      {children}
    </motion.div>
  );
}
